<template>
    <div v-dompurify-html="valueToBeSanitized"></div>
</template>

<script>
    export default {
        name: 'SanitizedHtml',
        props: {
            valueToBeSanitized: String
        }
    };
</script>